var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?[_c('loading-spinner')]:_vm._e(),_vm._v(" "),(!_vm.loading)?[_c('div',[_c('data-list',{model:{value:(_vm.summaryData),callback:function ($$v) {_vm.summaryData=$$v},expression:"summaryData"}})],1)]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }